import { Component } from 'preact';
import PropTypes from 'prop-types';
import { StepsProgress } from './components/StepsProgress';
import { ChooseModel } from './steps/ChooseModel';
import { ChooseUnitAndDate } from './steps/ChooseUnitAndDate';
import { MobileStepsProgress } from './components/MobileStepsProgress';
import { PersonalInfo } from './steps/PersonalInformation';
import { Summary } from './steps/Summary';

const STEP_COMPONENTS = {
  1: ChooseModel,
  2: ChooseUnitAndDate,
  3: PersonalInfo,
  4: Summary,
};

export class TestDrive extends Component {
  constructor(props) {
    super(props);

    this.containerRef = null;

    this.state = {
      currentStep: 1,
      modelId: null,
      modelName: null,
      versionId: null,
      versionName: null,
      versionSlug: null,
      image: null,
      unitSlug: null,
      unitName: null,
      preferredDate: null,
      preferredTime: null,
      preferredTimeLabel: null,
      name: '',
      email: '',
      phone: '',
      cpf: '',
    };

    this.setTestDriveData = this.setTestDriveData.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.formProps = this.formProps.bind(this);
    this.stepsProps = this.stepsProps.bind(this);
    this.scrollTopContainer = this.scrollTopContainer.bind(this);
  }

  setTestDriveData(data) {
    this.setState({
      ...data,
    });
  }

  prevStep() {
    if (this.state.currentStep === 1) return;

    this.scrollTopContainer();
    this.setState(prevState => ({
      currentStep: prevState.currentStep - 1,
    }));
  }

  nextStep() {
    if (this.state.currentStep === Object.keys(STEP_COMPONENTS).length) return;

    this.scrollTopContainer();
    this.setState(prevState => ({
      currentStep: prevState.currentStep + 1,
    }));
  }

  scrollTopContainer() {
    if (!this.containerRef) return;
    this.containerRef.scrollIntoView();
  }

  formProps() {
    return {
      ...this.state,
      prevStep: this.prevStep,
      nextStep: this.nextStep,
      setTestDriveData: this.setTestDriveData,
      unitOptions: this.props.units,
      channelConversion: this.props.channelConversion,
      conversionBrand: this.props.conversionBrand,
      conversionCategory: this.props.conversionCategory,
      homeLink: this.props.homeLink,
      privacyPolicyLink: this.props.privacyPolicyLink,
      showDataPermissions: this.props.showDataPermissions,
      dataPermissionsCustomText: this.props.dataPermissionsCustomText,
    };
  }

  stepsProps() {
    return {
      currentStep: this.state.currentStep,
      modelName: this.state.modelName,
      versionName: this.state.versionName,
      image: this.state.image,
      unitName: this.state.unitName,
      preferredDate: this.state.preferredDate,
      preferredTimeLabel: this.state.preferredTimeLabel,
    };
  }

  render() {
    const CurrentForm = STEP_COMPONENTS[this.state.currentStep];
    const formStepsCount = 3;
    const isSummary = this.state.currentStep === 4;

    return (
      <div className="test-drive" ref={node => (this.containerRef = node)}>
        <section className="form-container">
          {!isSummary ? (
            <div>
              <button
                className="test-drive__return-button"
                type="button"
                onClick={() => this.prevStep()}
                disabled={this.state.currentStep === 1}
              >
                <i className="icon icon-arrow-left" /> <b>Voltar</b>
              </button>
              <MobileStepsProgress
                currentStep={this.state.currentStep}
                stepsCount={formStepsCount}
              />
            </div>
          ) : null}

          <CurrentForm {...this.formProps()} />
        </section>

        {!isSummary ? <StepsProgress {...this.stepsProps()} /> : null}
      </div>
    );
  }
}

TestDrive.propTypes = {
  units: PropTypes.arrayOf({}),
  channelConversion: PropTypes.string,
  conversionBrand: PropTypes.string,
  conversionCategory: PropTypes.string,
  homeLink: PropTypes.string,
  privacyPolicyLink: PropTypes.string,
  showDataPermissions: PropTypes.bool,
  dataPermissionsCustomText: PropTypes.bool,
};
